/**
 * Created by MinhQuan on 8/24/2016.
 */
angular.module('nomenclature.ct', ['taric.model.ct', 'common.filter.commoditycode'])
    .controller('CorrelationTableController', function (CONSTANTS, $translatePartialLoader, CorrelationTableModel, CommonHelper, $state, $rootScope, $scope, $filter, $timeout, $stateParams, $translate, $location) {
        var correlationTableCtrl = this;
        correlationTableCtrl.init = function () {
            correlationTableCtrl.installationCountry = CONSTANTS.installationCountry;
            correlationTableCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            correlationTableCtrl.dateFormat = CONSTANTS.dateFormat;
            correlationTableCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            correlationTableCtrl.searchCriteria = CorrelationTableModel.getSearchCriteria();
            correlationTableCtrl.searchCommodityResult = CorrelationTableModel.getSearchCommodityResult();

            if (correlationTableCtrl.isExternalLink() && correlationTableCtrl.validateExternalParameters()) {
                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                correlationTableCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        correlationTableCtrl.isExternalLink = function(){
            // Verify 'frm' parameter to avoid auto-search after looking up commodity code.
            return (!$stateParams.frm || ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView')) && $stateParams.ds;
        };

        // Check whether the external parameters are valid or not
        correlationTableCtrl.validateExternalParameters = function(){
            return correlationTableCtrl.validateSearchForm();
        };

        correlationTableCtrl.openStartDatePicker = function ($event) {
            correlationTableCtrl.isStartDatePickerOpen = true;
        };
        correlationTableCtrl.openEndDatePicker = function ($event) {
            correlationTableCtrl.isEndDatePickerOpen = true;
        };

        correlationTableCtrl.search = function () {
            //Load data for the first page
            correlationTableCtrl.loadDataFromServer(1);
        };

        //Load data for a given page
        correlationTableCtrl.loadDataFromServer = function(page){
            if (!correlationTableCtrl.validateSearchForm()){
                return;
            }

            correlationTableCtrl.loadDataFromServerWithoutValidation(page);
        };

        //Load data for a given page without validation
        correlationTableCtrl.loadDataFromServerWithoutValidation = function(page){
            // Reset search result before searching
            correlationTableCtrl.resetSearchResult();
            correlationTableCtrl.searching = true;
            CorrelationTableModel.searchCommodities(page).then(function(searchCommodityResult) {
                correlationTableCtrl.searchCommodityResult =  searchCommodityResult;
                correlationTableCtrl.searching = false;
                correlationTableCtrl.updateBrowserURL();
            }, function(error){
                correlationTableCtrl.errorCode = error.data.code;
                correlationTableCtrl.errorParams = error.data.params;
                correlationTableCtrl.searching = false;
            });
        };

        /**
         * Query correlation table
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/nomenclature/ct?d={TradeDirection}&ccs={CommodityCodeStart}&cce={CommodityCodeEnd}&ds={DateStart}&de={DateEnd}&crt={CorrelationType}&l={Language}
         *
         * Example:
         * http://localhost:8080/arctictariff-public-web/#!/taric/nomenclature/ct?d=I&ccs=1005109000&cce=2208904100&ds=2015-01-01&de=2015-12-31&crt=N&l=en
         */
        correlationTableCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep additional parameters because there is no return to caller page
            $location.search({
                d: correlationTableCtrl.searchCriteria.direction,
                ccs: CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeStart),
                cce: CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeEnd),
                ds: CommonHelper.getBookmarkDateString(correlationTableCtrl.searchCriteria.startDate),
                de: CommonHelper.getBookmarkDateString(correlationTableCtrl.searchCriteria.endDate),
                crt: correlationTableCtrl.searchCriteria.correlationType,
                l : $translate.use()
            }).replace();
        };

        correlationTableCtrl.resetSearchResult = function() {
            correlationTableCtrl.searchCommodityResult = null;
            CorrelationTableModel.resetSearchResult();
        };

        correlationTableCtrl.validateSearchForm = function(){
            correlationTableCtrl.resetError();

            return correlationTableCtrl.validateDates() &&
                    correlationTableCtrl.validateCommodityCodes();
        };

        correlationTableCtrl.validateDates = function(){
            correlationTableCtrl.errorCode = CommonHelper.validateSimulationDate(correlationTableCtrl.searchCriteria.startDate);
            if(correlationTableCtrl.errorCode) {
                correlationTableCtrl.errorParams = {param0: CONSTANTS.pastDate};
                return false;
            }
            if (CommonHelper.compareDatesWithoutTime(correlationTableCtrl.searchCriteria.startDate, correlationTableCtrl.searchCriteria.endDate) > 0){
                correlationTableCtrl.errorCode = "i8n.common.invalidPeriod";
                return false;
            }
            return true;
        };

        correlationTableCtrl.validateCommodityCodes = function(){
            var ccRangeStart = CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeStart);
            var ccRangeEnd = CommonHelper.removeSpaceCharacters(correlationTableCtrl.searchCriteria.commodityCodeRangeEnd);
            if (ccRangeStart !== "" && ccRangeEnd !== "" && ccRangeStart.localeCompare(ccRangeEnd) > 0){
                correlationTableCtrl.errorCode = "i8n.qry.ct.invalid.commodityCodes";
                return false;
            }
            correlationTableCtrl.errorCode = CommonHelper.validateCommodityCode(correlationTableCtrl.searchCriteria.commodityCodeRangeStart, correlationTableCtrl.searchCriteria.direction);
            if (correlationTableCtrl.errorCode){
                return false;
            }
            correlationTableCtrl.errorCode = CommonHelper.validateCommodityCode(correlationTableCtrl.searchCriteria.commodityCodeRangeEnd, correlationTableCtrl.searchCriteria.direction);
            if (correlationTableCtrl.errorCode){
                return false;
            }

            return true;
        };

        correlationTableCtrl.resetError = function(){
            correlationTableCtrl.errorCode = null;
            correlationTableCtrl.errorParams = null;

        };

        correlationTableCtrl.searchCommodityResultPageChanged = function(page){
            correlationTableCtrl.loadDataFromServer(page);
        };

        correlationTableCtrl.selectCommodityCode = function (commodityCode, date, type, ccField) {

            $state.go('taric.nomenclature.sbn', {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(date),
                d: correlationTableCtrl.searchCriteria.direction,
                frm: 'taric.nomenclature.ct',
                type: type,
                ccField: ccField
            });
        };

        correlationTableCtrl.selectCommodityCodeRangeStart = function(commodityCode){
            correlationTableCtrl.selectCommodityCode(commodityCode, correlationTableCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeStart");
        };

        correlationTableCtrl.selectCommodityCodeRangeEnd = function(commodityCode){
            correlationTableCtrl.selectCommodityCode(commodityCode, correlationTableCtrl.searchCriteria.startDate, "lookup", "commodityCodeRangeEnd");
        };

        correlationTableCtrl.onStartDateChange = function (dateString) {
            correlationTableCtrl.resetError();
            correlationTableCtrl.searchCriteria.startDate = CommonHelper.formatDate(correlationTableCtrl.searchCriteria.startDate, dateString);
        };

        correlationTableCtrl.onEndDateChange = function (dateString) {
            correlationTableCtrl.resetError();
            correlationTableCtrl.searchCriteria.endDate = CommonHelper.formatDate(correlationTableCtrl.searchCriteria.endDate, dateString);
        };

        //export excel
        correlationTableCtrl.exportExcel = function() {
            if (!correlationTableCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningExport');
            CorrelationTableModel.searchCommodities().then(function(searchCommodityResult) {                

                var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
                correlationTableCtrl.searchCommodityAllResult = searchCommodityResult;
                document.getElementById('reportDateExtr').innerHTML = reportDate;
                
                setTimeout(function(){
                    var title = $filter('translate')('i8n.common.menu.query.nomenclature.correlationTable');
                	var ws = {
                		'!cols': [{
                			wpx: 330
                		}, {
                			wpx: 330
                		}, {
                			wpx: 330
                		}, {
                			wpx: 330
                		}]
                	};
                    
                	CommonHelper.printExcel("exportExcelTable", title, ws).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });

                }, 1000);    

            }, function(error){
                
            	// show errors here
              	$rootScope.$broadcast('stopSpinningPrint');
            });   
        };

        // export pdf
        correlationTableCtrl.print = function(options){

            if (!correlationTableCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }
            
          	$rootScope.$broadcast('startSpinningPrint');
          	CorrelationTableModel.searchCommodities().then(function(searchCommodityResult) {
            	
          		correlationTableCtrl.searchCommodityAllResult = searchCommodityResult;
            	setTimeout(function(){
                    
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(correlationTableCtrl.searchCriteria.startDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.common.menu.query.nomenclature.correlationTable')
                    }, 'p').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });

                }, 1000);

            }, function(error){
                
            	// show errors here
              	$rootScope.$broadcast('stopSpinningPrint');
            });
        };

        $scope.$on('exportDocument', function(event, data) {
    		
    		correlationTableCtrl.exportExcel();
        });
        
    	$scope.$on('printDocument', function(event, data) {
    		
    		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, correlationTableCtrl.print, true);
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            correlationTableCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                correlationTableCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });
    });


// WEBPACK FOOTER //
// ./app/taric/nomenclature/ct/correlation-table-search.js